var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6214_337102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.6 12.7724C1.16406 12.7724 0 11.5981 0 10.1496V3.28983C0 1.84127 1.16406 0.666992 2.6 0.666992H13.4C14.8359 0.666992 16 1.84127 16 3.28983V10.1496C16 11.5981 14.8359 12.7724 13.4 12.7724H8.81L4.79894 15.7993C4.35668 16.133 3.73 16.0418 3.39921 15.5957C3.26989 15.4212 3.2 15.2093 3.2 14.9916L3.19937 12.7724H2.6ZM8.4108 11.5619H13.4C14.1732 11.5619 14.8 10.9295 14.8 10.1496V3.28983C14.8 2.50984 14.1732 1.87753 13.4 1.87753H2.6C1.8268 1.87753 1.2 2.50984 1.2 3.28983V10.1496C1.2 10.9295 1.8268 11.5619 2.6 11.5619H4.39903L4.3992 12.167L4.39989 14.5887L8.4108 11.5619Z",
    fill: "#0D0C22"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6214_337102"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.35c76f04.svg";
export { ForwardRef as ReactComponent };